import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function removeOrganizationUser(id) {
  if (!id) {
    return {
      success: false,
      message: "제외할 사용자를 선택해 주세요.",
      data: null,
    };
  }

  try {
    const response = await authFetch(`${BACKEND_URL}/organization/users/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json().catch(() => ({}));
    return {
      success: response.ok && data?.success === true,
      message: data?.message ?? "",
      data: data?.data ?? null,
    };
  } catch (error) {
    console.error("[removeOrganizationUser] failed:", error);
    return {
      success: false,
      message: "사용자를 조직에서 제외하는 중 오류가 발생했습니다.",
      data: null,
    };
  }
}
